export const RAPID_FIRE = 2;
export const RACING_CHALLENGE = 3;
